/*jshint esversion: 6 */
import Barba from 'barba.js/src';
const $ = require('jquery');
import {
    TweenMax,
    TimelineMax,
    Power4,
    Power2,
    Expo
} from "gsap";
import CustomEase from '../../../vendors/CustomEase';
import PubSub from 'pubsub-js';

export function detailToHome(context, resolve, reject) {
    PubSub.publish('Initiate Callback', Barba.HistoryManager.prevStatus().url);

    const oldContainer = $(context.oldContainer),
        logo = oldContainer.find('.page--logo'),
        mask = {
            el: oldContainer.find('.page--masks'),
        },
        letters = oldContainer.find('.page-title p'),
        pageBanner = oldContainer.find('.page-banner .page-background .page-background--background-image'),
        maskEase = CustomEase.create("custom", "M0,0 C0.29,0 0.584,0.104 0.598,0.358 0.616,0.722 0.704,1 1,1");

    mask.top = mask.el.find('span.top');
    mask.bottom = mask.el.find('span.bottom');
    mask.right = mask.el.find('span.right');

    letters.not('.initialized').each((index, p) => {
        p.innerHTML = $(p).text().replace(/(\W|\w)/g, `<span>$&</span>`);
    });

    TweenMax.set([mask.top, mask.bottom], {
        height: 0
    });
    TweenMax.set(mask.right, {
        width: 0
    });
    mask.el.removeClass('no-js');
    PubSub.publish('scroll-top');

    PubSub.subscribe('scroll-complete', () => {
        TweenMax.fromTo(pageBanner, 1.2, {
            scale: 1.1
        }, {
            scale: 1,
            ease: maskEase
        });
        TweenMax.to(pageBanner.siblings('.overlay'), 1.2, {
            autoAlpha: 0
        });
        TweenMax.staggerTo(letters.find('span'), 1, {
            y: -100,
            ease: maskEase
        }, 0.015);
        // TweenMax.to([mask.top, mask.bottom], 0.6, {height: 100, ease: Power4.easeInOut, delay: 0.6});
        // TweenMax.to(mask.right, 0.6, {width: 150, ease: Power4.easeInOut, delay: 0.6});

        TweenMax.to(pageBanner, 1, {
            x: '-23%',
            ease: Power2.easeIn,
            delay: 0.5
        });
        TweenMax.to([mask.top, mask.bottom], 1, {
            height: '100%',
            ease: Power2.easeIn,
            delay: 0.5
        });
        TweenMax.to(mask.right, 1, {
            width: '100%',
            ease: Power2.easeIn,
            delay: 0.5,
            onComplete: () => {
                resolve();
            }
        });
    });

}

export function detailToHomeNext() {
    const newContainer = $(this.newContainer),
        oldContainer = $(this.oldContainer);

    // newContainer.css('visibility', 'visible');
    TweenMax.set(newContainer, {
        autoAlpha: 1
    });
    oldContainer.hide();

    // $('#siteHeader').removeClass('inverse');

    setTimeout(() => {
        this.done();
    }, 100);

}


// WEBPACK FOOTER //
// ./app/components/scrolling/DJAX_animations/detailToHome.js